import clsx from 'clsx';
import React from 'react';
import './UiToolbar.css';
import { UiBox, UiFlex } from '..';
export function UiToolbar(_a) {
    var padding = _a.padding, paddingLeft = _a.paddingLeft, paddingRight = _a.paddingRight, paddingHorizontal = _a.paddingHorizontal, position = _a.position, zIndex = _a.zIndex, noPadding = _a.noPadding, children = _a.children;
    var isBottom = position === 'bottom';
    return (React.createElement("div", { className: clsx('UiToolbar', noPadding && 'noPadding') },
        isBottom && React.createElement("div", { className: "placeholder" }),
        React.createElement(UiBox, { className: clsx('content-container', position && "position-" + position, zIndex && "zIndex-" + zIndex), padding: padding, paddingLeft: paddingLeft, paddingRight: paddingRight, paddingHorizontal: paddingHorizontal },
            React.createElement(UiFlex, { justifyContent: "space-between", spacing: 1, className: "content" }, children)),
        !isBottom && React.createElement("div", { className: "placeholder" })));
}
